export default __webpack_public_path__ + "static/media/m3ED_Zfo_400x400.a9b137d8.jpg";